import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environment';
import { Rest } from './rest';

const BACKEND_URL = environment.backendUrl + '/';

@Injectable()
export class AuditRest extends Rest {
  constructor(
    public http: HttpClient
  ) {
    super(http);
  }

  csvReport(request: any): any {
    let ref = BACKEND_URL + 'audit/csv?token=' + localStorage.token;
    if (request.startDate) { ref += '&startDate=' + new Date(request.startDate).toISOString(); }
    if (request.endDate) { ref += '&endDate=' + new Date(request.endDate).toISOString(); }
    window.location.href = ref;
  }

  csvReportApp(request: any): any {
    debugger;
    let ref = BACKEND_URL + 'audit/csvInst?token=' + localStorage.token;
    if (request.instanceId) { ref += '&instanceId=' + new String(request.instanceId).toString(); }
    window.location.href = ref;
  }
}
